import { findElementByClassName } from '../utils';

export const htmlInput = document.getElementById('html') as HTMLTextAreaElement;
export const jsInput = document.getElementById('js') as HTMLTextAreaElement;
export const cssInput = document.getElementById('css') as HTMLTextAreaElement;
export const allInputs = [htmlInput, jsInput, cssInput];

export const htmlOutput = document.getElementById('renderArea');
export const cssOutput = document.getElementById('injectedStyles');

export const handle = document.getElementById('handle');
export const enableJSCheckbox = document.getElementById(
  'enableJsCheckbox',
) as HTMLInputElement;

export const editor = findElementByClassName('editor');
export const alertElement = findElementByClassName('editorAlertJs');
export const percentRemaining = findElementByClassName(
  'remaining',
) as HTMLDivElement;
